import {DataFetcher, useGrpcRequest} from '@aboutyou/data-fetcher';
import {StoryPageService_MetadataLazy} from '@aboutyou/grpc-clients/tadarida/aysa_api/services/story_page/v1/service.grpc.lazy';
import {MetadataResponse} from '@aboutyou/grpc-clients/tadarida/aysa_api/services/story_page/v1/service.types';
import {Head} from '@aboutyou/head-elements';
import {RouterErrorHandler, useRecentFullUrl} from '@aboutyou/router';
import {TrackContentPageView} from '@aboutyou/tracking';
import React, {Fragment, memo} from 'react';
import {
  ensure404Page,
  extractMetaAndLinkTags,
  isSeoData,
  setDataTestIds,
} from '../../../shared-deprecated/metaUtils';
import {useEnsureRedirectData} from '../../../shared-deprecated/useEnsureRedirectData';
import {useStoryIdFromUrl} from '../utils/useStoryIdFromUrl';

export const StoryMeta: React.FC = props => {
  return (
    <DataFetcher
      request={useMetaData()}
      Error={RouterErrorHandler}
      View={MemoView}
      viewProps={props}
    />
  );
};

const useMetaData = () => {
  const storyId = useStoryIdFromUrl();
  const url = useRecentFullUrl();
  const ensureRedirectData = useEnsureRedirectData();

  return useGrpcRequest(
    StoryPageService_MetadataLazy,
    {
      storyId: storyId ?? -1,
      url,
    },
    {
      keepPreviousData: false,
      validateData: ensureRedirectData,
      validateError: ensure404Page,
      mockData: async () => {
        return (await import('../__mocks__/storyMeta.mock')).getStoryMetaData();
      },
    },
  );
};

const View: React.FC<MetadataResponse> = ({meta}) => {
  if (!isSeoData(meta)) {
    return null;
  }

  const seoData = meta.type.seoData;
  const [metaTags, linkTags] = setDataTestIds(
    extractMetaAndLinkTags(seoData.elements),
  );

  return (
    <Fragment>
      <TrackContentPageView pageTitle={seoData.title} />
      <Head meta={metaTags} link={linkTags}>
        <title data-testid="MetaTitle">{seoData.title}</title>
      </Head>
    </Fragment>
  );
};

const MemoView = memo(View);
